import React, { FC, useState, useEffect, useMemo } from "react";
import { RouteComponentProps } from "@reach/router";
import jwt_decode from "jwt-decode";

import { UserStore } from "../../../stores";
import { Login, Code } from "./screens";
import { AuthStore } from "./store";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { requestApi } from "../../../request-api";
// const coupleImg = require('../../assets/images/couple.png');

export const AuthScreen = ({ userStore }) => {
  const store = useMemo(() => new AuthStore(), []);

  const [screen, setScreen] = useState("phone");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [otp, setOtp] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
  const user = localStorage.getItem("user");
  setError("");
  const token = localStorage.getItem("x-access-token");
  const role = Number(localStorage.getItem("role_id")); // Convert to number

  if (token) {
    if (role === 1) {
      navigate("/super-admin");
    } else if (role === 2) {
      navigate("/auditor/dashboard");
    } else if (role === 3) {
      navigate("/compliancer/login");
    } else if (role === 4) {
      navigate("/approver/dashboard");
    } else {
      navigate("/unauthorized"); // fallback for unknown roles
    }
  } else {
    navigate("/sign-in"); // if no token
  }
}, [screen]);


  /**
   * Takes phone number and asks Firebase
   * to send SMS with auth code to it.
   */
  const onSubmitPhoneAuth = (phone, e) => {
    e.preventDefault();
    if (phone.length == 0) {
      setError("Please enter phone number");
    } else if (phone.length >= 10 && phone.length <= 12) {
      setPhoneNum(phone);
      onSubmitPhone(phone);
    } else {
      setError("Please enter correct number");
    }
  };

  const onSubmitPhone = (phone) => {
    setLoading(true);

    return store
      .sendCode(phone)
      .then((otp) => {
        if(otp){
        setScreen("code");
        }

        // if (otp) {
        //   alert(`Your OTP is: ${otp}`);
        // };
      })
      .catch((error) => {
        if (error.message.includes("user not found")) {
          setError("user not found");
        } else if (error.message.includes("user is blocked")) {
          setError("user is blocked");
        } else {
          setError(error.message);
        }
      })
      .finally(() => setLoading(false));
  };

  const onSubmitCode = async (code, otp) => {
    setLoading(true);
    setOtp(localStorage.getItem("otp"));
    return store
      .confirmCode(code, otp)
      .then(({ token, user }) => {
        return { token, user };
      })
      .then(({ token, user }) => {
        userStore.setToken(token);
        userStore.setUser(user);

        const decodedToken = jwt_decode(token);
        console.log(decodedToken.role_id, typeof decodedToken.role_id);

        if (decodedToken.role_id === 1) {
          navigate(`${directUrl}super-admin`);
        }
        if (decodedToken.role_id === 2) {
          navigate(`${directUrl}auditor/dashboard`);
        }
        if (decodedToken.role_id === 3) {
          navigate(`${directUrl}compliancer/dashboard`);
        }
        if (decodedToken.role_id === 4) {
          navigate(`${directUrl}approver/dashboard`);
        }
      })
      .catch((error) => {
        if (error.message.includes('"Invalid Credentials"')) {
          setError("Invalid code");
        } else if (error.message.includes("forbidden")) {
          setError("Access Forbidden");
        } else {
          setError(error.message);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <main>
      <section className="login-bg">
        {screen === "phone" ? (
          <Login onSubmit={onSubmitPhoneAuth} loading={loading} error={error} />
        ) : (
          <Code
            onSubmit={onSubmitCode}
            phoneNumber={phoneNum}
            error={error}
            loading={loading}
          />
        )}
      </section>
    </main>
  );
};
